import { addItemToCollection } from "directus/src/operations";

// Add createProject function
export async function createOpeningApplicant({ item }) {
    try {
        const query = {
            fields: [
                "id",
                "opening",
                "employee",
                "experience",
                "description",
                "resume_url",
                "is_selected",
            ],
        };

        const data = await addItemToCollection("opening_applicants", item, query);

        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}
